<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.HWC.OBS.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalBucketServiceResourceHwc:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalBucketServiceResourceHwc:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <object-storage-hwc-search
      ref="child"
    ></object-storage-hwc-search>
    <table-object-storage-hwc></table-object-storage-hwc>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ObjectStorageHwcSearch from "./ObjectStorageHwcSearch.vue";
import TableObjectStorageHwc from "./TableObjectStorageHwc.vue";
import Export from "../../hwc/Export";
let tableObjectStorageHwc = TableObjectStorageHwc;

export default {
  name: "ElasticComputeCloudResourceHwc",
  components: {
    ObjectStorageHwcSearch,
    TableObjectStorageHwc,
    Export
  },
  data() {
    return {
      modal_loading: false,
      updateLoading: false,
      companyId: ""
    };
  },
  methods: {
    update() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 501,
          accountType: 5
        })
        .then(res => {
          this.updateLoading = false;
          tableObjectStorageHwc.methods.showAll();
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIds: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName,
        name: this.$refs.child.name
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      //下载Excel文件
      this.$api.resourceManagement.exportHWCBucket(exportDTO).then(res => {
        this.exportResponse(res);
      });
    },
    exportResponse(res) {
      let fileName = "对象存储.xls";
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success("导出成功");
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/obs/ObjectStorageHwc.vue